import ErrorResult from "./error-result";
import ErrorResultText from "./error-result-text";

export default ErrorResult;

export
{
    ErrorResultText
};